import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, isRef as _isRef, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e460830"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-row p-4 border-t border-gray-200 bg-white" }
const _hoisted_2 = { class: "block truncate" }
const _hoisted_3 = { class: "absolute flex items-center inset-y-0 right-0 pr-2" }
const _hoisted_4 = { class: "flex flex-row" }
const _hoisted_5 = {
  class: "relative ml-auto z-0 inline-flex rounded-md shadow-sm -space-x-px",
  "aria-label": "Pagination"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Previous", -1))
const _hoisted_7 = { class: "h-5 w-5 text-center" }
const _hoisted_8 = {
  key: 0,
  class: "relative w-10 h-10 py-2 inline-block items-center cursor-pointer border text-sm text-center font-medium"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Next", -1))
const _hoisted_11 = { class: "h-5 w-5 text-center" }

import { computed, ref, watch } from "vue";
import type { PropType } from "vue";
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from "@headlessui/vue";
import { useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'Pagination',
  props: {
  config: {
    type: Object as PropType<{
      page: number;
      dataLength: number;
      count: number;
      pageCount: number;
      rowsPerPage: number;
      isEmitOnClick?: Boolean;
    }>,
    default: {},
  },
  isLagacy: Boolean,
},
  emits: ["update:config", "changePage"],
  setup(__props, { emit }) {

const props = __props

const CheckIcon = require("@heroicons/vue/solid/CheckIcon");
const SelectorIcon = require("@heroicons/vue/solid/SelectorIcon");
const route = useRoute();
const rowsPerPageOptions = [2, 5, 10, 20, 30, 40];
const configSync = computed({
  get: () => props.config,
  set: (value) => emit("update:config", value),
});
const pageInput = ref(configSync.value.page);

const pageRange = computed(() => {
  const { page, count, rowsPerPage } = configSync.value;
  const currentRange = page * rowsPerPage;
  return {
    from: currentRange - rowsPerPage + 1,
    to: currentRange > count ? count : currentRange,
  };
});
const rowsPerPageSync = computed({
  get: () => props.config?.rowsPerPage,
  set: (value) =>
    emit("update:config", { ...props.config, rowsPerPage: value }),
});

const onPageConfig = () => {
  emit("update:config", { ...configSync.value, page: pageInput.value || 1 });
};
const setPage = (method: string) => {
  let page =
    method === "next"
      ? Number(configSync.value.page) + 1
      : Number(configSync.value.page) - 1
      ;
  if (page < 1) {
    page = 1;
  }
  // if (page > props.config.pageCount) { page = props.config.pageCount }

  // if(!configSync.value.dataLength && configSync.value.count < configSync.value.rowsPerPage){
  //   return
  // }
  if (
    method === "next" &&
    configSync.value.dataLength < configSync.value.rowsPerPage
  ) {
    return;
  }
  if (props.config.isEmitOnClick) {
    emit("update:config", { ...props.config, page });
  }

  if (page > 0) emit("update:config", { ...props.config, page });
  pageInput.value = page;
};

const onKeyup = (e: any) => {
  e.preventDefault();
  const input = e?.target?.value;
  if (
    (e.code == "Enter" || e.code == "NumpadEnter" || e.keyCode == 13) &&
    input > 0
  ) {
    configSync.value.page = input;
  }
};

watch(configSync, (val) => {
  if (val.page === 1) {
    pageInput.value = 1;
  }
});




return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Listbox), {
      class: "w-44",
      as: "div",
      modelValue: _unref(rowsPerPageSync),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(rowsPerPageSync) ? (rowsPerPageSync).value = $event : null))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(ListboxButton), { class: "relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-pointer focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500" }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(rowsPerPageSync)), 1),
            _createElementVNode("span", _hoisted_3, [
              _createVNode(_unref(SelectorIcon), {
                class: "h-5 w-5 text-gray-400",
                "aria-hidden": "true"
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(ListboxOptions), { class: "absolute w-44 max-h-60 mt-1 py-1 z-10 bg-white shadow-lg rounded-md text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm" }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(rowsPerPageOptions, (option, i) => {
              return _createVNode(_unref(ListboxOption), {
                as: "template",
                key: i,
                value: option
              }, {
                default: _withCtx(() => [
                  _createElementVNode("li", {
                    class: _normalizeClass(["relative py-2 px-3 hover:text-white hover:bg-indigo-600 text-gray-900 cursor-pointer select-none", [
              _unref(rowsPerPageSync) == option
                ? 'font-bold text-indigo-600 hover:text-white'
                : 'font-normal',
            ]])
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("span", null, _toDisplayString(option), 1),
                      (_unref(rowsPerPageSync) == option)
                        ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                            key: 0,
                            class: "h-5 w-5 ml-auto",
                            "aria-hidden": "true"
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ], 2)
                ]),
                _: 2
              }, 1032, ["value"])
            }), 64))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("nav", _hoisted_5, [
      _createElementVNode("a", {
        href: "javascript:void(0)",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (setPage('previous'))),
        class: "relative inline-flex items-center w-10 h-10 px-2 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
      }, [
        _hoisted_6,
        _createElementVNode("span", _hoisted_7, [
          _createVNode(_component_font_awesome_icon, {
            class: "text-gray-500",
            icon: ['fas', 'chevron-left'],
            transform: "shrink-2"
          })
        ])
      ]),
      (__props.config.isEmitOnClick)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(__props.config.page), 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((pageInput).value = $event)),
              min: "1",
              class: "w-14 h-10 text-center border border-gray-300 focus:outline-none focus:ring-white",
              onKeyup: onKeyup
            }, null, 544), [
              [_vModelText, pageInput.value]
            ])
          ])),
      _createElementVNode("a", {
        href: "javascript:void(0)",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (setPage('next'))),
        class: "relative cursor-pointer inline-flex items-center w-10 h-10 px-2 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
      }, [
        _hoisted_10,
        _createElementVNode("span", _hoisted_11, [
          _createVNode(_component_font_awesome_icon, {
            class: "text-gray-500",
            icon: ['fas', 'chevron-right'],
            transform: "shrink-2"
          })
        ])
      ])
    ])
  ]))
}
}

})